<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    class="share-icon"
    :style="{ '--icon-color': color }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <path d="m8.59 13.51 6.83 3.98" />
    <path d="M15.41 6.51l-6.82 3.98" />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [String, Number],
    default: 16,
  },
  color: {
    type: String,
    default: '#333',
  },
})
</script>

<style scoped>
.share-icon {
  display: inline-block;
  vertical-align: middle;
  transition: opacity 0.2s;
  color: var(--icon-color, #333);
}

.share-icon:hover {
  opacity: 0.8;
}
</style>
